import { css } from '@emotion/react'

import { colors } from '../../../../styles/theme'

export default ({ isMinimal }) => css`
  background-color: ${colors.white};
  color: ${colors.silverChalice};

  .link-section {
    border-color: ${colors.silver};

    &-title {
      color: ${colors.black};
    }
  }

  .footer-bottom {
    border-color: ${colors.silver};

    a,
    [tabindex='0'] {
      color: ${colors.orange};

      &:focus {
        color: ${colors.orangeBright};
      }

      @media (hover: hover) {
        &:hover {
          color: ${colors.orangeBright};
        }
      }
    }

    .item-upsell {
      color: ${colors.honeyGold};
    }
  }

  li:not(:last-of-type)::after {
    background-color: ${isMinimal && colors.silver};
  }

  .copyright-text::before {
    background-color: ${colors.trout};
  }

  .sony-logo path {
    fill: ${colors.silverChalice};
  }
`
